import * as React from "react";
import { Modal } from "@grandvisionhq/common";
import { useScript } from "@grandvisionhq/lib-utils-react";
import { useIntl } from "@grandvisionhq/state";
import { pushVirtualMirrorDataLayerEvent } from "../../../../../../../utils/modules/VTO/VirtualMirror/utils/events.js";
/* empty css                        */
import { useVto } from "../../../../../../../../context/modules/VTO/context/VtoProvider.js";
import { vtoEvent } from "../../../../../../../../utils/modules/VTO/utils/vto-event.js";
import { initializationParams } from "../../../../../../../config/modules/VTO/VirtualMirror/config/initOptions.js";
const VirtualMirrorLoader = ({
  variants,
  onToggleWishlist,
  wishlistedSkuItems,
  transitionFeature
}) => {
  const { setVtoActive, setVmApp, config } = useVto();
  const { apiKey, environment, script, termsAndConditions } = config;
  const { locale, region } = useIntl();
  const privacyPolicyDataLayerEvent = "privacy_policy_click";
  const status = useScript(script, {
    removeOnUnmount: false
  });
  const onToggleWishlistRef = React.useRef();
  onToggleWishlistRef.current = onToggleWishlist;
  React.useEffect(() => {
    const onToggleWishlistHandler = (product) => {
      if (onToggleWishlistRef.current) {
        return onToggleWishlistRef.current(product.upc);
      }
      return Promise.reject();
    };
    if (status === "ready" && typeof window.vmmv !== "undefined") {
      try {
        const DEFAULT_INIT_PARAMS = initializationParams(
          apiKey,
          environment,
          locale,
          region,
          termsAndConditions
        );
        const config2 = {
          ...DEFAULT_INIT_PARAMS,
          ...variants,
          onToggleWishlist: onToggleWishlistHandler,
          wishlistedUpcs: wishlistedSkuItems ?? [],
          transitionFeature,
          onClose: () => {
            setVtoActive(false);
          },
          onPrivacyAgree: () => {
            pushVirtualMirrorDataLayerEvent({
              event: privacyPolicyDataLayerEvent,
              interactionType: "continue_click"
            });
          },
          onPrivacyReject: () => {
            pushVirtualMirrorDataLayerEvent({
              event: privacyPolicyDataLayerEvent,
              interactionType: "cancel_click"
            });
            setVtoActive(false);
          }
        };
        const vmAppInstance = new window.vmmv.VMWidgetApp();
        vmAppInstance.setConfig(config2).then(() => {
          setVmApp(vmAppInstance);
          vmAppInstance.init();
        }).catch((error) => {
          console.error(error);
          setVtoActive(false);
        });
      } catch (error) {
        console.error(error);
        setVtoActive(false);
      }
    }
  }, [status]);
  return /* @__PURE__ */ React.createElement("div", { className: "virtual-mirror__target" });
};
const VirtualMirrorModal = ({
  variants,
  onToggleWishlist,
  wishlistedSkuItems,
  transitionFeature
}) => {
  const { vmApp, setVtoActive, setVmApp } = useVto();
  React.useEffect(() => {
    const sku = variants?.products?.[0]?.upc;
    if (sku) {
      vtoEvent("vto.tryon.open", { sku });
    }
    return () => {
      if (sku) {
        vtoEvent("vto.close", { sku });
      }
    };
  }, [variants?.products]);
  if (!variants) {
    return null;
  }
  const onModalClose = async () => {
    if (vmApp) {
      await vmApp.unmount();
      setVmApp(null);
    }
    setVtoActive(false);
  };
  return /* @__PURE__ */ React.createElement("div", { className: "virtual-mirror", "data-t": "virtual-mirror" }, /* @__PURE__ */ React.createElement(
    Modal,
    {
      activeTrap: false,
      "data-t": "virtual-mirror-modal",
      isOpen: true,
      className: "virtual-mirror__modal",
      onModalClose
    },
    /* @__PURE__ */ React.createElement(
      VirtualMirrorLoader,
      {
        variants,
        onToggleWishlist,
        wishlistedSkuItems,
        transitionFeature
      }
    )
  ));
};
export {
  VirtualMirrorLoader,
  VirtualMirrorModal
};
//# sourceMappingURL=VirtualMirrorModal.js.map
